/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ridge_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How are the curves computed?`)
};

const es_ridge_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se calculan las curvas?`)
};

const de_ridge_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie werden die Kurven berechnet?`)
};

const nl_ridge_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe worden de curven berekend?`)
};

const fr_ridge_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment les courbes sont-elles calculées ?`)
};

const it_ridge_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come vengono calcolate le curve?`)
};

const pt_br2_ridge_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como as curvas são calculadas?`)
};

const pt_ridge_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como são calculadas as curvas?`)
};

const ja_ridge_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`曲線はどのように計算されますか?`)
};

const zh_ridge_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`曲线是如何计算的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ridge_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ridge_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ridge_faq_q3", locale)
	if (locale === "en") return en_ridge_faq_q3(inputs)
	if (locale === "es") return es_ridge_faq_q3(inputs)
	if (locale === "de") return de_ridge_faq_q3(inputs)
	if (locale === "nl") return nl_ridge_faq_q3(inputs)
	if (locale === "fr") return fr_ridge_faq_q3(inputs)
	if (locale === "it") return it_ridge_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_ridge_faq_q3(inputs)
	if (locale === "pt") return pt_ridge_faq_q3(inputs)
	if (locale === "ja") return ja_ridge_faq_q3(inputs)
	return zh_ridge_faq_q3(inputs)
};